<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
    <fieldset class="k-form-fieldset">
        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="site" [text]="customMsgService.translate('local')"> </kendo-label>
            <kendo-dropdownlist textField="nome" valueField="id" formControlName="site" [valuePrimitive]="true"
                [defaultItem]="placeHolder" [data]="listItems" #site required>
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('local') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

        </kendo-formfield>
    </fieldset>
    <h5>{{ customMsgService.translate('nomeEquipa') }}</h5>
    <fieldset class="k-form-fieldset">

        <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="pt" [text]="customMsgService.translate('pt')"> </kendo-label>
            <kendo-textbox (inputBlur)="inputBlur()" formControlName="pt" [clearButton]="true" #pt required>
            </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('pt') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield orientation="horizontal">
            <kendo-label [for]="en" [text]="customMsgService.translate('en')"> </kendo-label>
            <kendo-textbox formControlName="en" [clearButton]="true" #en> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('en') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield orientation="horizontal">
            <kendo-label [for]="fr" [text]="customMsgService.translate('fr')"> </kendo-label>
            <kendo-textbox formControlName="fr" [clearButton]="true" #fr> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
                customMsgService.translate('fr') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

        </kendo-formfield>

        <kendo-dialog-actions>
            <button kendoButton (click)="cancelChanges()">
                {{ customMsgService.translate('cancel') }}
            </button>
            <button kendoButton (click)="saveChanges()" themeColor="primary" [disabled]="!formGroup.valid">
                {{ customMsgService.translate('saveChanges') }}
            </button>
        </kendo-dialog-actions>

    </fieldset>
</form>